import {PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {FBRowOptions} from "FormBuilder/Core/FBRow.Options";
import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {ContainerDataRetriever} from "FormBuilder/Core/FormBuilder.Model";
import {SingleEvent} from "shared/utilities/Events/SingleEvent";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {PublishOnceEvent} from "shared/utilities/Events/PublishOnceEvent";
import {PriceManager} from "FormBuilder/Utilities/Managers/PriceManager/PriceManager";
import {FBRowModel} from "FormBuilder/Core/FBRow.Model";
import {GroupPricePerItemCalculator} from "FormBuilder/Core/Calulators/GroupPricePerItemCalculator";
import {GroupOfFieldsInGroupCalculator} from "FormBuilder/Core/Calulators/GroupOfFieldsInGroupCalculator";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {FBRepeaterItemModel} from "./FBRepeaterItem.Model";
import {FBRepeaterOptions} from "./FBRepeater.Options";
import {FBColumnOptions} from "FormBuilder/Core/FBColumn.Options";
import {FBRepeaterItemOptions} from "./FBRepeaterItem.Options";
import {FBRow} from "FormBuilder/Core/FBRow";
import {ModelSerialize} from "FormBuilder/Core/Models/ModelBase";
import {FieldFactory} from "FormBuilder/FieldFactory";
import {FBRepeaterItem} from "./FBRepeaterItem";


export class FBRepeaterModel extends FBFieldWithPriceBaseModel<FBRepeaterOptions,FBColumnModel> implements ContainerDataRetriever{
    FieldValueChanged: SingleEvent<FBFieldBaseModel>;
    IsField: boolean;
    IsLoaded: boolean;
    OnLoad: PublishOnceEvent;
    PriceManager: PriceManager;
    ProductPriceChanged: SingleEvent;
    VariationChanged: SingleEvent;
    @ModelSerialize()
    public Rows:FBRowModel[];
    public CreatedRows:FBRowModel[];

    constructor(Options: FBRepeaterOptions, Parent: any,previousData:any=null) {
        super(Options, Parent,previousData);
        this.IsField=true;
        this.FieldValueChanged=new SingleEvent();
        this.OnLoad=new PublishOnceEvent();
        this.ProductPriceChanged=new SingleEvent();
        this.PriceManager=new PriceManager(this);
        this.Rows=[];
        this.CreatedRows=[];


        let previousValues:string[][]=this.GetPreviousDataProperty('Value',[]);
        let quantity=this.GetPreviousDataProperty( 'Quantity',this.ParseNumber(this.Options.QuantityDefaultValue));
        if(quantity==0)
            quantity=1;

        for(let row of this.Options.Rows)
            this.Rows.push(new FBRowModel(row,this));


        if(previousValues.length==0)
            this.AppendRow();

        for(let value of previousValues)
            this.AppendRow(value);


        this.PriceManager.UpdateQuantity(quantity);
        if(this.Options.PriceType==PriceTypeEnum.price_per_item)
            this.calculator=new GroupPricePerItemCalculator(this.PriceManager);
        if(this.Options.PriceType==PriceTypeEnum.sum_of_fields_in_group)
            this.calculator=new GroupOfFieldsInGroupCalculator(this.PriceManager);

        this.calculator.Initialize(this);
        this.Quantity=quantity;


        if(this.FormBuilder.VariationChanged!=null)
            this.FormBuilder.VariationChanged.Subscribe(this,()=>this.VariationChanged.Publish());


    }

    public ExecuteFirstCalculation(){
        for(let item of this.GetItems())
        {
            item.ExecuteFirstCalculation();
        }
    }


    GetDynamicFieldNames(): string[] {
        let names:string[]=['FBRepeater'];

        this.Rows.forEach(row=>row.Columns.forEach(column=>names=names.concat(column.Field.GetDynamicFieldNames())))
        return names;
    }

    protected InitializePriceCalculator() {

    }

    public get PreviousData(){
        return {Fields:this.GetPreviousDataProperty('Value',[])};
    }



    public GetFirstItem():FBRepeaterItemModel{
        if(this.CreatedRows.length==0)
            return null;
        return this.CreatedRows[0].Columns[0].Field as FBRepeaterItemModel;
    }

    public GetItems():FBRepeaterItemModel[]{
        return this.CreatedRows.map(x=>x.Columns[0].Field as FBRepeaterItemModel);
    }

    public DeleteField(field: FBFieldBaseModel) {
        let row=FBRowOptions;
        for(let currentRow of this.GetFirstItem().Rows)
        {
            if(currentRow.Columns.find(x=>x.Field==field)!=null)
            {
                this.GetFirstItem().Rows.splice(this.GetFirstItem().Rows.indexOf(currentRow),1);
                this.Refresh();
            }
        }
    }

    GetStoresInformation(): boolean {
        return true;
    }

    public GetValue() {
        let values:any[]=[];
        for(let item of this.GetItems())
        {
            let rows=item.Rows;
            if(rows.some(x=>x.Columns[0].Field.GetIsUsed()&&x.Columns[0].Field.GetStoresInformation()))
            {
                let itemValues:any[]=[];
                values.push(itemValues);
                rows.forEach(row=>{
                    if(row.Columns[0].Field.GetIsUsed()&&row.Columns[0].Field.GetStoresInformation())
                        itemValues.push(row.Columns[0].Field.SerializeEntry());
                })
            }
        }
        return values;


    }

    protected InternalSerialize(obj: any) {
        super.InternalSerialize(obj);
        obj.Value=this.GetValue();
    }

    GetIsUsed(): boolean {
        return this.GetValue().length>0;
    }

    GetRowByFieldId(fieldId:number): FBRowModel {
        return this.FormBuilder.GetRowByFieldId(fieldId)
    }

    GetRows(): FBRowModel[] {
        return this.Rows;
    }

    GetNextFieldId(): number {
        return this.FormBuilder.GetNextFieldId();
    }

    GetFields(): FBFieldBaseModel[] {
        return [];
    }

    public GetVariationValue(VariationName:string)
    {
        return (document.querySelector('#'+VariationName.toLowerCase()) as HTMLSelectElement).value;
    }

    GetFieldById(id: any): FBFieldBaseModel {
        return undefined;
    }



    GetProductPrice(): any {
        return this.FormBuilder.GetProductPrice();
    }

    GetSalePrice(): any {
        return this.FormBuilder.GetSalePrice();
    }

    GetRuler(): any {
        return (this.FormBuilder as ContainerDataRetriever).GetRuler();
    }

    public CreateSubRow(options:FBRowModel)
    {
        return this.FormBuilder.CreateSubRow(options);
    }

    public get RepeaterItems():FBRepeaterItemModel[]{
        return this.CreatedRows.map(x=>x.Columns[0].Field as FBRepeaterItemModel);
    }

    public AppendRow(previousData:any=null) {
        let newFieldOptions=new FBRepeaterItemOptions().Merge();
        for(let row of this.Rows)
        {
            newFieldOptions.Rows.push(new FBRowOptions().Merge(row.Options.ToObject()));
        }





        let column=new FBColumnOptions().Merge();
        column.Field=newFieldOptions;

        let row=new FBRowOptions().Merge();
        row.Columns.push(column);


        let rowModel=new FBRowModel(row,this,previousData);

        if(typeof rednaoProductDesigner!='undefined'&& (rednaoProductDesigner as any).IsDesign=='1'){
            (rowModel.Columns[0].Field as FBRepeaterItemModel).Rows=this.Rows;
        }

        let repeaterModel=rowModel.Columns[0].Field as FBRepeaterItemModel;
        this.RepeaterItems.forEach(x=>x.ShowAddButton=false);

        repeaterModel.ShowAddButton=true;
        repeaterModel.OnAdd.Subscribe(this,()=>this.AppendRow());
        repeaterModel.OnRemove.Subscribe(this,(item)=>this.RemoveRow(item));
        this.CreatedRows.push(rowModel);
        this.Refresh();
    }


    public Recreate(){
        if(this.CreatedRows.length>0)
            (this.CreatedRows[0].Columns[0].Field as FBRepeaterItemModel).Refresh();
        this.Parent.Refresh();
    }

    public Remove(item: FBRowModel) {
        if(this.Rows.indexOf(item)>=0)
        {
            this.Rows.splice(this.Rows.indexOf(item),1);
            this.Refresh();
        }

    }


    private RemoveRow(item:FBRepeaterItemModel) {
        for(let row of this.CreatedRows)
            for(let colum of row.Columns)
            {
                let field:FBRepeaterItemModel=colum.Field as FBRepeaterItemModel;
                if(field==item)
                {
                    this.CreatedRows.splice(this.CreatedRows.indexOf(row),1);
                    if(this.CreatedRows.length>0)
                        (this.CreatedRows[this.CreatedRows.length-1].Columns[0].Field as FBRepeaterItemModel).ShowAddButton=true;
                    this.Refresh();
                }
            }
    }

    GetId(): string {
        return this.Options.Id.toString();
    }

    GetPluginURL(): any {
        return this.FormBuilder.GetPluginURL();
    }
}




